import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import Banner from "../components/Banner";
import { FaInstagramSquare } from "react-icons/fa";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const Home = () => {
  const [products, setProducts] = useState([]);
  const [catList, setCatList] = useState([]);
  const [data, setData] = useState([]);
  const [showA, setShowA] = useState(true);
  const [select,setSelect] = useState('');

  useEffect(() => {

    fetchProduct()
      const dataArray1 = [];
      const db = firebase.firestore();
    db.collection("catagories")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          dataArray1.push({ id: doc.id, ...doc.data() });
        });
        setCatList(dataArray1);
      });
  }, []);

  const fetchProduct = async() => {
    const dataArray = [];
    const db = firebase.firestore();
    db.collection("products")
      .orderBy("price", "asc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          dataArray.push({ id: doc.id, ...doc.data() });
        });
        setProducts(dataArray);
        setData(dataArray);
      });
  }

  const handleButtonClick = (ctitle) => {
    setShowA(false);
    setSelect(ctitle);
    const filtered = data.filter((item) =>
      item.cat === ctitle
    );
    setProducts(filtered);
  };
  const handleButtonAll = (divNumber) => {
    if(divNumber === 1){
      fetchProduct()
      setSelect('');
      setShowA(true);
    }
  };

  return (
    <Layout>
      <Banner />
      <div className="mhome">
        <div className="ihome">
        <div className="horizontal-scroll-container">  
          <div className="i-home1">
            <button onClick={() => handleButtonAll(1)}>
              <h4>All</h4>
            </button>
          </div>
          {catList.map((c,i) => {
            return (
              <div className="i-home1" key={c.id}>
                <button onClick={() => handleButtonClick(c.title)}>
                  <h4>{c.title}</h4>
                </button>
              </div>
            )
          })}
          </div>
        </div>
          { showA && <h2 className="title-b">All</h2>}
          { select !== '' ? <h2 className="title-b">{select}</h2> : ''}
          <div className="bundles">
            {products !== ""
              ? products.map((p, i) => (
                  <div className="card">
                    <img src={p.image} alt="Pic" />
                    <h3>{p.price}</h3>
                    <h4>{p.title}</h4>
                    <h6>{p.cat}</h6>
                    <h6>{p.com}</h6>
                    <button>
                      <a href={p.link} target="_blank" rel="noreferrer">
                        Buy Now
                      </a>
                    </button>
                  </div>
                ))
              : "No Products"}
          </div>

        <div className="social">
          <h6>Follow us :</h6>
          <h5>
            <FaInstagramSquare />
            <a href="https://www.instagram.com/mar_store.uk/">
              {" "}
              MAR Online Store UK
            </a>
          </h5>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
